import React from 'react';
import MemorySection from './settings/MemorySection';

const MemoryPage: React.FC = () => {
  return (
    <div className="space-y-6 p-6">
      <MemorySection />
    </div>
  );
};

export default MemoryPage;